import type { SubmitScoringMetricsPayload } from '@playcastdotio/Messaging';

export class RawMetricsStore {
  private payload: SubmitScoringMetricsPayload | null = null;

  set(payload: SubmitScoringMetricsPayload): void {
    this.payload = payload;
  }

  get(): SubmitScoringMetricsPayload | null {
    return this.payload;
  }

  timestamp(): number | null {
    return this.payload?.clientTimestamp ?? null;
  }
}
